import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../../APIHelpers/Responses";

export const eiwrsKitSchemaManagementServices = {
  //Kit Schema Management
  addNewEIWRSKitSchemaManagement,
  updateEIWRSKitSchemaManagementData,
  deleteEIWRSKitSchemaManagementData,
  softDeleteRestoreEIWRSKitSchemaManagement,
  getEIWRSKitSchemaManagementData,
};

// Add New Kit Schema Management
async function addNewEIWRSKitSchemaManagement(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewEIWRSKitSchemaManagement`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Kit Schema Management
async function updateEIWRSKitSchemaManagementData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateEIWRSKitSchemaManagementData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Kit Schema Management
async function softDeleteRestoreEIWRSKitSchemaManagement(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreEIWRSKitSchemaManagement`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Kit Schema Management
async function deleteEIWRSKitSchemaManagementData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteEIWRSKitSchemaManagementData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Kit Schema Management
async function getEIWRSKitSchemaManagementData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitSchemaManagementData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getEIWRSKitSchemaManagementData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}